import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateEOIDetails } from '~/services/AgentHub/AgentService';

import { Eoi } from '~/types/services/agentHub';

interface UpdateEoiDetailsParams {
  id: string;
  eoiData: Eoi;
}

export function useUpdateEoiDetails() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, eoiData }: UpdateEoiDetailsParams) => {
      return await updateEOIDetails(id, eoiData);
    },
    onSuccess: (data, variables) => {
      queryClient.setQueryData(['eoi', variables.id], data);
      queryClient.invalidateQueries({ queryKey: ['list-eoi'] });
    },
  });
}
